import { BottomDrawerModal } from "@/components/shared/bottom-drawer-modal";
import { View } from "@/components/ui";
import { ImageCarousel } from "@/components/shared/image-carousel";
import { Star } from "@/components/shared/icons";
import { Typography } from "../typography";
import type { ServiceTypeEnum } from "@/__generated__/graphql";
import { getBeautyServiceLabel } from "@/lib/service/helpers";
import { WorkerAvatar } from "../worker-avatar";

export function WorkerPortfolio({
  openModal,
  onClose,
  cleanerProfilePhoto,
  serviceCleaner,
  serviceRating,
  reviewNumber,
  slotDay,
  slotStartTime,
  slotEndTime,
  images,
  serviceTypes,
}: {
  openModal: boolean;
  onClose: () => void;
  cleanerProfilePhoto: string;
  serviceCleaner: string;
  serviceRating: number;
  reviewNumber: number;
  slotDay: string;
  slotStartTime: string;
  slotEndTime: string;
  images: string[];
  serviceTypes: ServiceTypeEnum[];
}) {
  const handleClose = (isOpen: boolean) => {
    if (!isOpen) {
      onClose();
    }
  };

  return (
    <BottomDrawerModal open={openModal} onOpenChange={handleClose}>
      <View className="flex flex-col">
        <View className="mb-3 flex flex-row border-b border-secondary-border pb-3">
          <WorkerAvatar
            alt="home-beauty-avatar"
            src={cleanerProfilePhoto}
            size={56}
          />
          <View className="pl-2">
            <Typography variant="body-lg" className="py-1">
              {serviceCleaner}
            </Typography>
            <View className="flex cursor-pointer flex-row items-center gap-1">
              <Star weight="fill" className="color-warning" size={16} />
              <View className="flex flex-row divide-x">
                <Typography variant="body-md" color="info" className="mr-1">
                  {serviceRating.toFixed(1)}/5
                </Typography>
                <Typography variant="body-md" color="info" className="pl-1">
                  {`| ${reviewNumber} Review(s)`}
                </Typography>
              </View>
            </View>
          </View>
        </View>
        <View>
          <Typography variant="body-sm" color="foreground-intermediate">
            Available: {slotDay} at {slotStartTime}-{slotEndTime}
          </Typography>
          <Typography className="my-3" variant="body-sm">
            {`${getBeautyServiceLabel(serviceTypes)} Design Samples`} ini y
          </Typography>
          <View className="mb-5 overflow-hidden rounded-2xl">
            <ImageCarousel
              images={images}
              height={403}
              autoPlay={true}
              showArrows={false}
              pagingEnabled={false}
            />
          </View>
        </View>
      </View>
    </BottomDrawerModal>
  );
}
